"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var ChipArray_static_1 = require("./ChipArray.static");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            minWidth: 0,
        },
        labelContainer: {
            display: 'flex',
            overflow: 'hidden',
            flexWrap: 'wrap',
            marginBottom: -8,
        },
        preContent: {
            alignSelf: 'center',
            marginRight: ChipArray_static_1.preContentMarginRight,
            marginBottom: ChipArray_static_1.chipItemMarginBottom,
            minWidth: 0,
            '&:empty': {
                marginRight: 0,
            },
        },
        chip: {
            marginRight: ChipArray_static_1.chipItemMarginRight,
            marginBottom: ChipArray_static_1.chipItemMarginBottom,
            '&:last-of-type': {
                marginRight: 0,
            },
        },
        numberMoreChip: {
            alignSelf: 'center',
            marginBottom: ChipArray_static_1.chipItemMarginBottom,
        },
        toggleButton: {
            alignSelf: 'center',
            cursor: 'pointer',
            marginBottom: ChipArray_static_1.chipItemMarginBottom,
        },
        invisible: {
            visibility: 'hidden',
        },
    });
});
